import { render, staticRenderFns } from "./GitHubVersionLink.vue?vue&type=template&id=51840e56&scoped=true&"
import script from "./GitHubVersionLink.vue?vue&type=script&lang=ts&"
export * from "./GitHubVersionLink.vue?vue&type=script&lang=ts&"
import style0 from "./GitHubVersionLink.vue?vue&type=style&index=0&id=51840e56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51840e56",
  null
  
)

export default component.exports